import {
  AddressesEndpoints,
  IFullAddressSuggestionsResponse,
  IFullAddressSuggestionsDTO,
} from '@/models/addresses.model';
import { addressesHttpClient, ApiResponse } from '@/utils';

class AddressesAPI {
  static getAddressSuggestions(params: IFullAddressSuggestionsDTO): ApiResponse<IFullAddressSuggestionsResponse> {
    return addressesHttpClient.get<IFullAddressSuggestionsResponse>(AddressesEndpoints.GET_SUGGESTIONS, { params });
  }
}

export default AddressesAPI;
